
import { mapData } from "@/utilities/DataMapping";
import Utils from "@/utilities/Utils";
import { PagePartComponent, ResourceAndTextLayout, ResourceContentType } from "@/model/Enums";
import { IResource, Resource } from "@/model/Resource";
import { IPagePartOptions } from "./IPagePartOptions";

export class ResourceAndTextOptions implements IPagePartOptions {

    constructor(data?: IPagePartOptions) {
        // client wants default to be text-on-right
        this.layoutType = ResourceAndTextLayout.TextOnRight;

        if (data) this.update(data);
    }

    update(data: IPagePartOptions): ResourceAndTextOptions {
        mapData(data, {
            root: () => this,
            resource: (data: IResource) => this.resource.update(data)
        });
        if(!this.widthPercent || this.widthPercent < 0) this.widthPercent = 50; // default
        return this;
    }

    get component(): PagePartComponent {
        return PagePartComponent.ResourceAndText;
    }
    set component(value: PagePartComponent) {
        if(value != this.component) console.warn(`IPagePartOptions - trying to set component ${this.component} -> ${value}`)
    }

    // ADDING PROPERTIES - you also need to update the toJSON method!

    resourceID: string = Utils.emptyGuidValue;

    html: string = "";

    get isRedLineQuestion(): boolean { return false; }
    set isRedLineQuestion(value: boolean) {
        if(value) console.warn("IPagePartOptions - unsupported - trying to set isRedLineQuestion to true")
    }

    contentType: ResourceContentType = ResourceContentType.None;

    layoutType: ResourceAndTextLayout = ResourceAndTextLayout.Default;

    resource: Resource = new Resource();

    shouldAutoPlay: boolean = false;

    vimeoID: string = "";

    wistiaID: string = "";

    momentoUrl: string = "";

    widthPercent: number = 50;

    imageAlt: string = "";

    // getter / setter properties are not serialised by JSON.stringify unless we do this:
    toJSON(): any {
        return {
            component: this.component,
            html: this.html,
            resourceID: this.resourceID,
            isRedLineQuestion: this.isRedLineQuestion,
            contentType: this.contentType,
            layoutType: this.layoutType,
            resource: this.resource,
            shouldAutoPlay: this.shouldAutoPlay,
            vimeoID: this.vimeoID,
            wistiaID: this.wistiaID,
            momentoUrl: this.momentoUrl,
            widthPercent: this.widthPercent,
            imageAlt: this.imageAlt
        };
    }
}